import { useState, useEffect } from 'react'; // Merged imports
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Phone, Mail, MapPin, Clock, CheckCircle2 } from 'lucide-react';

// Unified Backend URL logic
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/$/, "");
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [settings, setSettings] = useState({
    business_phone: '',
    business_email: '',
    business_address: '',
    business_hours: ''
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        if (response.data) {
          setSettings(response.data);
        }
      } catch (err) {
        console.error("Backend unreachable, using default view", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          <div>
            <h2 className="text-3xl font-bold text-primary mb-8">Contact Information</h2>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <Phone className="w-6 h-6 text-primary" />
                <div>
                  <h3 className="font-semibold text-primary">Phone</h3>
                  <a href={`tel:${settings?.business_phone || ''}`} className="text-muted-foreground hover:text-primary">
                    {settings?.business_phone || 'Loading...'}
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Mail className="w-6 h-6 text-primary" />
                <div>
                  <h3 className="font-semibold text-primary">Email</h3>
                  <a href={`mailto:${settings?.business_email || ''}`} className="text-muted-foreground hover:text-primary">
                    {settings?.business_email || 'Loading...'}
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <MapPin className="w-6 h-6 text-primary" />
                <div>
                  <h3 className="font-semibold text-primary">Location</h3>
                  <p className="text-muted-foreground">{settings?.business_address || 'Perth, WA'}</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Clock className="w-6 h-6 text-primary" />
                <div>
                  <h3 className="font-semibold text-primary">Business Hours</h3>
                  <p className="text-muted-foreground whitespace-pre-line">
                    {settings?.business_hours || 'Mon-Fri: 8am - 6pm'}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Your Form code goes here */}
          
        </div>
      </div>
    </section>
  );
};

export default Contact;
